export function dataURLtoBlob(dataURL) {
    const byteCharacters = atob(dataURL.split(',')[1]);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const croppedBlob = new Blob([byteArray], { type: 'image/jpeg' });
    return croppedBlob;
}
